import { memo, FunctionComponent } from 'react';
import { HomeProjectSection } from '../common/HomeProjectSection.js';

interface UrgentProjectsSectionProps {
    baseSearchURL: string;
    loadProjects: () => void;
    getProjects: (url: string) => object;
    detectedLocation?: object;
}

const UrgentProjectsSection: FunctionComponent<UrgentProjectsSectionProps> = function (props: UrgentProjectsSectionProps) {
    const mostUrgent = props.baseSearchURL + '?max=25&hasPhoto=true';

    return (
        <HomeProjectSection searchURL={mostUrgent} title="Most urgent projects"
            projects={props.getProjects(mostUrgent)} loadProjects={props.loadProjects}
            className="projects-most-urgent"
            description="HIGHEST ECONOMIC NEED + CLOSEST TO FINISH LINE + FEWEST DAYS LEFT">
        </HomeProjectSection>
    );
};

export default memo(UrgentProjectsSection);
